import React from "react";
import { Button, notification } from "antd";

const Notification = ({
  type = "info",
  message,
  description,
  showButton = false,
  buttonText = "Show Notification",
}) => {
  const [api, contextHolder] = notification.useNotification();

  const openNotification = () => {
    api[type]({
      message,
      description,
    });
  };

  return (
    <>
      {contextHolder}
      {showButton && (
        <Button type="primary" onClick={openNotification}>
          {buttonText}
        </Button>
      )}
    </>
  );
};

// Function to trigger notifications globally
export const showNotification = (type, message, description) => {
  notification[type]({
    message,
    description,
  });
};

export default Notification;

// using function
// showNotification("success", "Login Successful", "You are now logged in!");
// using component

{/* <Notification
  type="success"
  message="Welcome!"
  description="You have successfully logged in."
  showButton={false}
/>; */}
